import { Property as MikroOrmProperty } from '@mikro-orm/decorators/legacy'
import type { PropertyOptions } from '@mikro-orm/core'
import { IsInt } from 'class-validator'
import { applyDecorators } from '@nestjs/common'
import { Property } from '~/modules/core/decorators'
import { SchemaObject } from '~/swagger-patcher/swagger-patcher'


interface IntOptions<T extends object> extends Omit<PropertyOptions<T>, 'type' | 'columnType'> {
  example?: SchemaObject['example']
  examples?: SchemaObject['examples']
}

/**
 * INT 列装饰器，声明一个 32 位整数列。
 *
 * 自动应用 MikroORM `@Property({ type: 'int' })`、`@IsInt()` 验证及 Swagger schema。
 *
 * @param options - 列配置，支持 `unsigned` 设置无符号
 *
 * @example
 * ```typescript
 * @Entity()
 * class Product {
 *   @Int({ unsigned: true, comment: '库存数量' })
 *   stock: number
 * }
 * ```
 */
export function Int<T extends object>(options?: IntOptions<T>): (target: T, propertyName: string) => void {
  return (target, propertyKey) => {
    MikroOrmProperty({ ...options, type: 'int' })(target, propertyKey)

    applyDecorators(
      IsInt(),
      Property({
        optional: options?.nullable,
        lazy: options?.lazy,
        schema: {
          type: 'integer',
          minimum: options?.unsigned ? 0 : -2147483647,
          maximum: options?.unsigned ? 4294967295 : 2147483647,
          description: options?.comment,
          example: options?.example,
          examples: options?.examples,
          required: !options?.nullable,
        },
      }),
    )(target, propertyKey)
  }
}
